<template>
    <div class="container-medium well m-auto mt-8 relative">
        <ul class="m-0">
            <li
                v-for="(plugin, indexPlugin) in plugins"
                :key="indexPlugin"
                class="dinlineb span_2 gutters valign-top acenter"
            >
                <a
                    :href="plugin.url"
                    :onClick="plugin.call"
                    :target="plugin.target"
                    class="block px-2 py-4 b-1-black-hover cpointer br w-160 m-auto pref-link"
                >
                    <CompassIcon
                        v-if="plugin.compassicon"
                        :icon="plugin.compassicon"
                        size="large"
                    />
                    <icon-svg
                        v-else-if="plugin.iconSvg"
                        view-box="0 0 26 26"
                        :width="26"
                        :height="26"
                        :iconName="plugin.iconSvg"
                        style="color: grey"
                    >
                        <component :is="plugin.iconSvg" />
                    </icon-svg>
                    <i v-else :class="plugin.icon" class="grey fs-6"></i>
                    <p class="gray-100 fs-3 semibold m-0 mt-2">{{ plugin.label }}</p>
                </a>
            </li>
        </ul>
        <CompassButton
            v-if="permissions.can_add_module"
            :label="$t.__('settings.SettingsInternalPlugin.add_modules')"
            type="secondary"
            class="absolute bottom-right-5"
            @click="redirectionAddModules"
        />
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import TreasuryNav from 'vcomponents/icons/IconTreasury.vue';
import { createNamespacedHelpers } from 'vuex';
const settingsStore = createNamespacedHelpers('settingsStore');

export default {
    components: {
        IconSvg,
        TreasuryNav,
    },
    computed: {
        ...settingsStore.mapGetters({
            plugins: 'getInternalPlugins',
            permissions: 'getPermissions',
        }),
    },
    methods: {
        redirectionAddModules() {
            return goToUrl('/?_f=store&amp;showme=apps');
        },
    },
};
</script>

<style lang="scss" scoped>
.pref-link {
    align-items: center;
    display: flex;
    flex-direction: column;
    ::v-deep path {
        fill: var(--colors-sellsy-grayscale-60);
    }
}
</style>
